import { useEffect, useRef, useState, type ReactNode } from 'react'
import { ApiError, type Api } from '../../infra/api'
import { Screen } from './Screen'

type Join = 'joining' | 'joined' | 'failed'

/**
 * Signed in, but not invited (the API's 403 not_invited). Joins the waitlist once on arrival. If the API says the
 * person is invited after all (an admin added them a moment ago), `onInvited` loads the app.
 */
export function NotInvited({ api, email, action, onInvited }: { api: Api; email: string | null; action: ReactNode; onInvited: () => void }) {
  const [join, setJoin] = useState<Join>('joining')
  const asked = useRef(false)
  useEffect(() => {
    if (asked.current) return
    asked.current = true
    api.joinWaitlist().then(
      () => setJoin('joined'),
      (e: unknown) => (e instanceof ApiError && e.code === 'already_invited' ? onInvited() : setJoin('failed')),
    )
  }, [api, onInvited])

  return (
    <Screen title={join === 'failed' ? 'Invite-only for now.' : "You're on the waitlist."} action={action}>
      You're signed in as <b>{email ?? 'this account'}</b>. cpg.computer is invite-only during the pilot.{' '}
      {join === 'failed'
        ? "We couldn't add you to the waitlist just now. Write to "
        : join === 'joined'
          ? "We've added you to the waitlist. Questions, or want in sooner? Write to "
          : 'Adding you to the waitlist. Questions? Write to '}
      <a href="mailto:hello@cpg.computer">hello@cpg.computer</a>
      {join === 'failed' ? " and we'll add you." : '.'}
    </Screen>
  )
}
